import styled from 'styled-components';

export const ImpcStockLevelsStyle = styled.div`
  .fkTuFL {
    max-height: 16.5em;
  }
  .rt-table .rt-tbody .rt-tr-group {
    &:nth-child(
      ${({ selectedRowIndex }) => {
        if (typeof selectedRowIndex !== 'number') {
          return -1;
        }
        return selectedRowIndex + 3;
      }}
    ) > .rt-tr {
      background-color: #dbffdb;
    }
  }
  }
`;
